<p-card class="mt-5">
  <app-card-title key="project.steps.overallResults.projectDecision" />

  @if (winnerCandidatesResource.isLoading()) {
    <app-loading />
  } @else {
    <app-winner-selection
      [projectId]="projectId()"
      [options]="providerOptions()"
      [isReadOnly]="isProviderSelectionReadOnly()"
      [preselectedId]="preselectedProviderId()"
      (winnerTagged)="onWinnerTagged($event)"
    />

    @if (winnerSelected()) {
      @if (hrToolProviderDecisionResource.isLoading()) {
        <app-loading />
      } @else {
        @if (winner(); as winner) {
          <div class="flex flex-col gap-4">
            @if (contractFormValues(); as formValues) {
              <app-panel
                [titleKey]="winner.providerTenantMappingResponse.originalName"
                icon="pi-trophy"
                iconColor="text-green"
              >
                <app-provider-selection-winner
                  [offerProviderDetails]="winner"
                  [projectId]="projectId()"
                  [inputObject]="formValues"
                  [comment]="contractComment()"
                  [isReadOnly]="isCurrentStepLocked()"
                  [isReasonReadOnly]="isWinnerReasonReadOnly()"
                  (submitOutput)="saveContractDecision($event)"
                  (isFormComplete)="isDecisionFormComplete.set($event)"
                  (reasonSatisfied)="
                    onReasonSatisfied(winner.providerTenantMappingResponse.hrToolDirectusId, $event)
                  "
                ></app-provider-selection-winner>
              </app-panel>
            }

            @for (
              looser of loosers();
              track looser.providerTenantMappingResponse.hrToolDirectusId
            ) {
              <app-panel
                [titleKey]="looser.providerTenantMappingResponse.originalName"
                icon="pi-times-circle"
                iconColor="text-button-red"
              >
                <app-decision-reason-field
                  [projectId]="projectId()"
                  [hrToolDirectusId]="looser.providerTenantMappingResponse.hrToolDirectusId"
                  [initialReasonText]="looser.reasonText"
                  [isReadOnly]="isWinnerReasonReadOnly()"
                  (reasonSatisfied)="
                    onReasonSatisfied(looser.providerTenantMappingResponse.hrToolDirectusId, $event)
                  "
                ></app-decision-reason-field>
              </app-panel>
            }
          </div>

          @if (canTagWinnerProvider()) {
            <div class="flex justify-end mt-4">
              <p-button
                [label]="'project.tag.winnerProvider.label' | transloco"
                [pTooltip]="'project.tag.winnerProvider.tooltip' | transloco"
                (onClick)="tagWinnerProvider()"
                data-testid="complete-button"
              ></p-button>
            </div>
          }

          @if (canArchiveProject()) {
            <div class="flex justify-end mt-4">
              <p-button
                [label]="'project.archive.label' | transloco"
                [pTooltip]="'project.archive.tooltip' | transloco"
                (onClick)="archiveProject()"
                data-testid="archive-button"
              ></p-button>
            </div>
          }
        }
      }
    }
  }
</p-card>
